export interface ActivityOpenTarget {
  activityId: string;
  title: string;
  kind: string;
  viewerType: 'iframe' | 'image' | 'video' | 'download';
  src: string;
  external?: boolean;
  delivery?: string;
  fileName?: string;
}

interface WorkspaceActivityViewerProps {
  target: ActivityOpenTarget;
  onBack: () => void;
}

export default function WorkspaceActivityViewer({ target }: WorkspaceActivityViewerProps) {
  const downloadHref = target.src;

  return (
    <div className="workspace-activity-viewer" aria-label={target.title}>
      <div className="workspace-activity-viewer-body">
        {target.viewerType === 'iframe' && (
          <iframe
            className="workspace-activity-frame"
            src={target.src}
            title={target.title}
            allow="autoplay; fullscreen"
          />
        )}

        {target.viewerType === 'image' && (
          <img className="workspace-activity-image" src={target.src} alt={target.title} />
        )}

        {target.viewerType === 'video' && (
          <video className="workspace-activity-video" src={target.src} controls playsInline>
            <track kind="captions" />
          </video>
        )}

        {target.viewerType === 'download' && (
          <div className="workspace-activity-download-panel">
            <p>
              Open this activity document from your Mentology Activities vault.
              {target.fileName ? ` (${target.fileName})` : ''}
            </p>
            <a className="workspace-activity-open-link" href={downloadHref} target="_blank" rel="noopener noreferrer">
              Open activity
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
